import { getCompany, getUserId } from '../_utils/storage_handler';
import { sendFetch, POST_OPTIONS, GET_OPTIONS, sendSellerFetch } from './base.service';

const BASE_PATH = '/orders';

export const findOrdersByCompany = async (company) => {
    return await sendFetch(`${BASE_PATH}/all/company/${company}`, GET_OPTIONS);
}

export const findOrdersDesp = async (company) => {
    return await sendFetch(`${BASE_PATH}/all-desp/${company}`, GET_OPTIONS);
}

export const findAllByGroupDetailsOrder = async (uuid_order) => {
    return await sendFetch(`${BASE_PATH}/regroup-details-order/${getCompany()}/${uuid_order}`, GET_OPTIONS);
}

export const findOrdersDetailChecked = async (company) => {
    return await sendFetch(`${BASE_PATH}/all-checked-detail/${company}`, GET_OPTIONS);
}

export const findOrdersByCompanyGroupDate = async (body) => {
    return await sendFetch(`${BASE_PATH}/all-group-date`, POST_OPTIONS, body);
}

export const findAllByGroupDetails = async () => {
    return await sendFetch(`${BASE_PATH}/group-details/${getCompany()}`, GET_OPTIONS);
}

export const groupPending = async () => {
    return await sendFetch(`${BASE_PATH}/group-pending/${getCompany()}`, GET_OPTIONS);
}

export const groupPendingMarked = async () => {
    return await sendFetch(`${BASE_PATH}/group-pending-marked/${getCompany()}`, GET_OPTIONS);
}

export const groupPendingEnro = async () => {
    return await sendFetch(`${BASE_PATH}/group-pending-enro/${getCompany()}`, GET_OPTIONS);
}

export const groupPendingPdf = async () => {
    return await sendFetch(`${BASE_PATH}/group-pending-pdf`, GET_OPTIONS);
}

export const groupPendingMarkedPdf = async () => {
    return await sendFetch(`${BASE_PATH}/group-pending-marked-pdf`, GET_OPTIONS);
}

export const groupPendingEnroPdf = async () => {
    return await sendFetch(`${BASE_PATH}/group-pending-enro-pdf`, GET_OPTIONS);
}


export const findAllByGroupDetailsForClient = async () => {
    return await sendFetch(`${BASE_PATH}/group-details-client/${getCompany()}`, GET_OPTIONS);
}

export const findOrdersByCompanyGroupDatePaged = async (company, refDate, days) => {
    let year = refDate.getFullYear();
    let month = refDate.getMonth() + 1;
    let date = refDate.getDate();
    return await sendFetch(`${BASE_PATH}/all-group-date-paged/company/${company}/${date}/${month}/${year}/${days}`, GET_OPTIONS);
}

export const findOrdersByClient = async (company, uuid) => {
    return await sendFetch(`${BASE_PATH}/all-order-client/${company}/${uuid}`, GET_OPTIONS);
}

export const findOrdersByCompanyGroupClient = async (company) => {
    return await sendFetch(`${BASE_PATH}/all-group-client/company/${company}`, GET_OPTIONS);
}

export const findOrdersByCompanyState = async (company, state) => {
    return await sendFetch(`${BASE_PATH}/all/company/state/${company}/${state}`, GET_OPTIONS);
}


export const findOrdersIdsByCompany = async () => {
    return await sendFetch(`${BASE_PATH}/order-ids/${getCompany()}`, GET_OPTIONS);
}

export const findOrdersIdsByCompanyAndDate = async (dateStart,dateEnd) => {
    return await sendFetch(`${BASE_PATH}/order-ids-date/${getCompany()}/${dateStart}/${dateEnd}`, GET_OPTIONS);
}

export const createOrder = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editOrder = async (body) => {
    return await sendFetch(`${BASE_PATH}/edit`, POST_OPTIONS, body);
}

export const editOrderCheck = async (body) => {
    return await sendFetch(`${BASE_PATH}/edit-check`, POST_OPTIONS, body);
}

export const updateOrder = async (body) => {
    return await sendFetch(`${BASE_PATH}/order-update/`, POST_OPTIONS,body);
}

export const deleteOrderDetail = async (body) => {
    return await sendFetch(`${BASE_PATH}/delete`, POST_OPTIONS, body);
}

export const sectionOrderDetail = async (body) => {
    return await sendFetch(`${BASE_PATH}/section`, POST_OPTIONS, body);
}

export const remisionOrderDetail = async (body) => {
    return await sendFetch(`${BASE_PATH}/remision`, POST_OPTIONS, body);
}

export const consultFormula = async (body) => {
    return await sendFetch(`${BASE_PATH}/consult-formula`, POST_OPTIONS, body);
}

export const processFormula = async (body) => {
    return await sendFetch(`${BASE_PATH}/process-formula`, POST_OPTIONS, body);
}

export const aproveOrders = async (body) => {
    return await sendFetch(`${BASE_PATH}/aprove`, POST_OPTIONS, body);
}

export const aproveOrdersBN = async (body) => {
    return await sendFetch(`${BASE_PATH}/aprove-bn`, POST_OPTIONS, body);
}

export const displayPDFOrder = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/pdf`, POST_OPTIONS, body);
}

export const displayPDFOrderId = async (id) => {
    return await sendSellerFetch(`${BASE_PATH}/pdf/id/${id}`, GET_OPTIONS);
}

export const displayPDFOrderReport = async (body) => {
    return await sendFetch(`${BASE_PATH}/report`, POST_OPTIONS, body);
}

export const displayPDFOrderClientReport = async (body) => {
    return await sendFetch(`${BASE_PATH}/report-client`, POST_OPTIONS, body);
}

export const findOrdersByCompanyAndSeller = async () => {
    return await sendSellerFetch(`${BASE_PATH}/all/company/seller/${getCompany()}/${getUserId()}`, GET_OPTIONS);
}

export const findOrdersByCompanyAndSellerGroupDate = async (year, month) => {
    return await sendSellerFetch(`${BASE_PATH}/all-group-date/company/seller/${getUserId()}/${year}/${month}`, GET_OPTIONS);
}

export const findOrdersByCompanyAndSellerGroupClient = async () => {
    return await sendSellerFetch(`${BASE_PATH}/all-group-client/company/seller/${getCompany()}/${getUserId()}`, GET_OPTIONS);
}



//check ppistola

export const checkProduct = async (uuid_detail,check) => {
    return await sendFetch(`${BASE_PATH}/order-detail/remision-state/${uuid_detail}/${check}`, GET_OPTIONS);
}

export const checkDryCleaning = async (uuid_detail) => {
    return await sendFetch(`${BASE_PATH}/order-detail/to-enr/${uuid_detail}`, GET_OPTIONS);
}

export const resetCheckeOrders = async (company) => {
    return await sendFetch(`${BASE_PATH}/reset-checked/company/${company}`, GET_OPTIONS);
}

/**
 * 
 * Services to use barcode lector 
 */

export const toEnr = async (id) => {
    return await sendFetch(`${BASE_PATH}/order-detail/to-enr/${id}`, GET_OPTIONS);
}

export const toRemission = async (id) => {
    return await sendFetch(`${BASE_PATH}/order-detail/remission/${id}`, GET_OPTIONS);
}

export const toDryCleaner = async (uuid_detail) => {
    return await sendFetch(`${BASE_PATH}/order-detail/to-dry/${uuid_detail}`, GET_OPTIONS);
}

/**
 * Report excel order state
 */
export const generateOrderStateReportOrdersByClient = async (company, uuid) => {
    return await sendFetch(`${BASE_PATH}/excel-order-client/${company}/${uuid}`, GET_OPTIONS);
}